import { fetch } from '@/shared/fetch';
import { IChildParentalAuthorityStatus } from '@/shared/interfaces';

export const fetchChildrenParentalAuthorityStatus = async (): Promise<
    IChildParentalAuthorityStatus[]
> => {
    return await fetch<IChildParentalAuthorityStatus[]>(
        '/api/patients/children/parental-authority-status',
        'GET',
    );
};
